import { actionTypes, bonusType } from "./bonusTypes";


export const initialState: bonusReducerType = {
  bonusUsed: false,
  percentageFillProfile: 0,
  bonusEditModalOpened: false,
  showCongrats: false,
  bonusData: []
};

type bonusReducerType = {
  bonusUsed: boolean;
  percentageFillProfile: number;
  showCongrats: boolean;
  bonusEditModalOpened: boolean;
  bonusData: Array<bonusType>
};

const bonusReducer = (state = initialState, { type, payload }: any): bonusReducerType => {
  switch (type) {
    case actionTypes.SET_FILL_BONUS_AVAILABLE:
      return {
        ...state,
        bonusUsed: payload
      };
    case actionTypes.SET_BONUS_DATA:
      return {
        ...state,
        bonusData: payload
      };
    case actionTypes.SET_FILL_BONUS_PERCENT:
      return {
        ...state,
        percentageFillProfile: Math.floor(payload)
      };
    case actionTypes.SET_SHOW_CONGRATS:
      return {
        ...state,
        showCongrats: payload
      };
    case actionTypes.SET_BONUS_EDIT_MODAL_OPENED:
      return {
        ...state,
        bonusEditModalOpened: payload
      };
    default:
      return state;
  }
};

export default bonusReducer;
